import type { ComponentProps } from 'react'
import type { IconProps } from '../icons/types'
import { cn } from '../lib/cva'
import { Button } from './Button'
import { ClientLogo } from './ClientLogo'
import { Link } from './Link'
import { Text } from './Text'

export interface ModuleHeaderProps {
	breadcrumb: {
		label: string
		to?: string
	}[]
	title?: string
	logo?: {
		url: string
		name: string
	}
	buttons?: {
		label: string
		icon?: React.FC<IconProps>
		onClick: () => void
		variant: ComponentProps<typeof Button>['variant']
		disabled?: boolean
	}[]
}

export const ModuleHeader = ({ breadcrumb, title, logo, buttons }: ModuleHeaderProps) => {
	return (
		<>
			<div className={cn('flex justify-between items-start', buttons && 'mb-8')}>
				<div>
					{breadcrumb.map(({ label, to }, index) => {
						const isLast = index === breadcrumb.length - 1
						return (
							<Link
								key={to ?? index}
								href={to}
								variant='breadcrumb'
								size='small'
								className='mb-1'
								withChevron={!isLast}
								disabled={isLast}>
								{label}
							</Link>
						)
					})}
				</div>
				{logo && (
					<div className='flex gap-x-3 items-center'>
						<ClientLogo url={logo.url} />
						<Text variant='small' weight='semibold'>
							{logo.name}
						</Text>
					</div>
				)}
			</div>

			{(title || buttons?.length) && (
				<div className='flex justify-between items-center mb-4 mt-4'>
					{title && (
						<Text variant='h3' weight='semibold' className='capitalize my-4'>
							{title}
						</Text>
					)}
					<div className='flex gap-x-2'>
						{buttons?.map((button) => (
							<Button
								key={button.label}
								variant={button.variant}
								onClick={button.onClick}
								icon={button.icon}
								disabled={button.disabled}>
								{button.label}
							</Button>
						))}
					</div>
				</div>
			)}
		</>
	)
}
